export default __webpack_public_path__ + "static/media/battery-half-solid.5904ace6.svg";